/* eslint-disable @typescript-eslint/no-unused-vars */
import { Injectable } from '@angular/core';
import { CanMatch, Route, UrlSegment, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanMatch {
  constructor(private router: Router) {}

  canMatch(route: Route, segments: UrlSegment[]): boolean {
    const token = localStorage.getItem('token');
    if (!token) {
      location.href = '/login';
      return false;
    }
    return true;
  }
}
